export default "__VITE_ASSET__N3bfZtsN__"